import script from "./NotificationSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationSettings.vue?vue&type=script&setup=true&lang=js"

import "./NotificationSettings.vue?vue&type=style&index=0&id=438eb631&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-438eb631"]])

export default __exports__